import React from 'react';
import {Table} from 'react-bootstrap'
import CompetitorQuotaTabella from './CompetitorQuotaTabella';
import CompetitorQuotaBF from './CompetitorQuotaBF';
import { IppicaConst } from '../../constants/ippica';
import  {useDispatch} from 'react-redux';
import * as IppicaActions from '../../redux/ippica/actions';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const RowCompetitor = (props) => {
    const competitor = props.competitor
    const evento_id = props.evento_id
    const classColumns = props.classColumns
    
    const dispatch = useDispatch()

    // ritorna l'oggetto quota del competitor per la specialita e il concessionario indicati,
    // oppure undefined se non presente. Prima la stessa catena di accessi veniva ripercorsa
    // fino a piu' volte per ogni cella
    const getQuota = (specialita_id, concessionario_codice) => {
      const quote_specialita = props.quoteEvento && props.quoteEvento[competitor.specialita[specialita_id]]
      return quote_specialita && quote_specialita[concessionario_codice]
    }

  const CellaQuotaComponent = (quota_cella, concessionario_codice, specialita_id, alert_class) => {
    /* costruisco la cella quota che deve essere visualizzata in base al concessionario che deve essere visualizzato
      - quota_cella: oggetto quota gia' recuperato, undefined se non presente
      - concessionario_codice: codice del concessionario
      - specialita_id: id della specialita
      - alert_class: classe da applicare alla cella in caso di alert
    */
    let cellaQuota = <></>
    if(quota_cella){
      if(concessionario_codice != IppicaConst.CONCESSIONARIO_BETFAIR){
        if (quota_cella['value']>0){
          cellaQuota = <CompetitorQuotaTabella alert_class={alert_class} quota={quota_cella['value']}></CompetitorQuotaTabella>

        }else{
          cellaQuota = '-'
        }
      }else{
        let quota = 0
        let quota_2 = 0
        if(quota_cella['value']>0){
          quota = quota_cella['value']
        }
        if(quota_cella['value_2']>0){
          quota_2 = quota_cella['value_2']
        }
        cellaQuota = <CompetitorQuotaBF quota={quota} quota_2={quota_2}></CompetitorQuotaBF>
      }
      
    }else{
      cellaQuota = '-'
    }
    return cellaQuota
  }
    

  const getAlertClass = (quota_cella, concessionario_codice, specialita_id) => {
    /* 
    Indico la classe da applicare alla cella in caso di alert. Se BF_COMBINATO è abilitato e sono presenti
    entrambi gli alert, usa quella classe, altrimenti mantieni la vecchia priorità (prima banca, poi punta)
      - quota_cella: oggetto quota gia' recuperato, undefined se non presente
      - concessionario_codice: codice del concessionario
      - specialita_id: id della specialita
    */
    let returnClass = ''
    if(quota_cella){
        const hasBF = props.evento.specialita_attive[String(specialita_id)]
          && quota_cella['alert'] & IppicaConst.VALUE_ALERT_BF
          && props.alert_abilitati['BF']['abilitato'];

        const hasBFPunta = props.evento.specialita_attive[String(specialita_id)]
          && quota_cella['alert'] & IppicaConst.VALUE_ALERT_BF_PUNTA
          && props.alert_abilitati['BF_PUNTA']['abilitato'];
        
        const isCombinedAlertEnabled = props.alert_abilitati['BF_PUNTA_BANCA']?.abilitato ?? false;
        
        // Se l'alert combinato è abilitato e ho entrambi gli alert, uso la classe combinata
        if(hasBF && hasBFPunta && isCombinedAlertEnabled){
            returnClass = ' bf-alert-punta-banca '
        }else if(hasBF && !isCombinedAlertEnabled){
            returnClass = ' bf-alert-banca '
        }else if(hasBFPunta && !isCombinedAlertEnabled){
          returnClass = ' bf-alert-punta '
        }
      }
    return returnClass;
  }
  
  
  const getStyleTd = (quota_cella, concessionario_codice, specialita_id) =>{
    /*
      Ritorno lo stile delle colonne in base alla presenza o meno dell'alert inserendo il puntatore
    */
    let style = {}
    if(quota_cella && props.evento.specialita_attive[String(specialita_id)] && quota_cella['alert'] > 0)
      style.cursor = "pointer"
    if(!props.evento.specialita_attive[String(specialita_id)])
      style.fontWeight = "Normal"
    style.borderRight = "1px solid #ccc"
    return style;
  }

    return (
      competitor.visible && competitor.enabled &&
        <div className={classColumns + ' card my-1 mx-1'} key = {competitor.quota_descrizione + evento_id + '1'} >
                  <div key = {competitor.quota_descrizione + evento_id + '3'} className={'fw-bold fs-marcatore row'}>
                  <div className='col-3 text-nowrap overflow-hidden ps-1'>
                  <span style={{cursor:'pointer'}}><i className="bi bi-x-lg p-1" onClick = {()=>{
                      dispatch(IppicaActions.setStateEnabledPlayer(props.evento, competitor, false))
                    }
                  }
                    title='Elimina cavallo'
                  ></i></span>
                  <span title={(competitor.open? 'Chiudi cavallo': 'Apri cavallo')} style={{cursor:'pointer', userSelect:'none'}} onClick = {()=>{
                          dispatch(IppicaActions.setStateOpenCompetitor(!competitor.open, props.evento, competitor));
                  }}>{competitor.quota_descrizione}</span>
                  </div>
                  <div className='col-9'>
                  {!competitor.open && <>
                      <Table className='table-borderless mb-0 w-auto' align={'right'} striped="">
                        <tbody key = {competitor.quota_descrizione + evento_id + '5'}>
                              <tr>
                                <td width={150}   className='align-middle fs-quote text-muted pe-3'  align={'right'}>
                                </td>
                                {props.specialita && props.specialita.map((spec)=>
                                  {
                                    var quota_cella = getQuota(spec.id, IppicaConst.CONCESSIONARIO_VIRTUALE);
                                    // recupero le classi da fornire alla cella in caso di alert
                                    var alert_class = getAlertClass(quota_cella, IppicaConst.CONCESSIONARIO_VIRTUALE, spec.id)
                                    return (
                                      spec.visible && 
                                      <td 
                                      
                                      key = {IppicaConst.CONCESSIONARIO_VIRTUALE + spec.id + evento_id} 
                                      className={'fs-specialita fs-quote text-center' 
                                                + (!props.evento.specialita_attive[String(spec.id)]? ' text-muted font-weight-normal': '')
                                                }
                                      onClick={()=>{
                                        if(quota_cella && props.evento.specialita_attive[String(spec.id)] && quota_cella['alert'] > 0){
                                          dispatch(IppicaActions.setStateOpenCompetitor(!competitor.open, props.evento, competitor));
                                        }
                                      }}
                                      style={getStyleTd(quota_cella, IppicaConst.CONCESSIONARIO_VIRTUALE, spec.id)}
                                      width={IppicaConst.LARGHEZZA_SPECIALITA}>
                                      {CellaQuotaComponent(quota_cella, IppicaConst.CONCESSIONARIO_VIRTUALE, spec.id, alert_class)
                                      }
                                      </td>

                                    );   
                                  }
                                  
                                )}
                              </tr>
                          </tbody>
                      </Table>
                      </> }
                      {competitor.open && <>
                      <Table className='table-borderless mb-0 w-auto' align={'right'} striped="">
                      
                        <tbody key = {competitor.quota_descrizione + evento_id + '5'}>
                        {props.tipoVisualizzazione != 0 ? <tr>
                        <td width={90}></td>
                        {props.specialita && props.specialita.map((spec)=>
                          spec.visible && <td key={spec.id + evento_id} className='text-center fw-bold align-middle fs-quote ' width={70} >{spec.descrizione}</td>
                          )}
                        </tr>: <></>
                        }
                        
                          {props.concessionari && props.concessionari.map((concessionario)=>
                            concessionario.visible && <tr  key={concessionario.concessionario_codice + evento_id + '1'}>
                              <td 
                                width={90}   
                                className='align-middle fs-quote text-muted pe-3'  
                                align={'right'}
                                style={{borderRight: "1px solid #ccc"}}
                                > {concessionario.concessionario_descrizione}</td>
                              {props.specialita && props.specialita.map((spec)=>{
                                var quota_cella = getQuota(spec.id, concessionario.concessionario_codice)
                                var alert_class = getAlertClass(quota_cella, concessionario.concessionario_codice, spec.id)
                                return (
                                  spec.visible && 
                                  <td 
                                    title={(quota_cella ? quota_cella['quota_descrizione'] : '')}  
                                    key = {concessionario.concessionario_codice + spec.id + evento_id} 
                                    className={'fs-specialita fs-quote text-center'
                                            + (!props.evento.specialita_attive[String(spec.id)]? ' text-muted font-weight-normal': '')
                                            } 
                                    onClick={()=>{
                                      if(quota_cella && props.evento.specialita_attive[String(spec.id)] && quota_cella['alert'] > 0){
                                        dispatch(IppicaActions.setStateOpenCompetitor(!competitor.open, props.evento, competitor));
                                        } 
                                    }}
                                    style={getStyleTd(quota_cella, concessionario.concessionario_codice, spec.id)}

                                    width={IppicaConst.LARGHEZZA_SPECIALITA}>
                                      {CellaQuotaComponent(quota_cella, concessionario.concessionario_codice, spec.id, alert_class)}
                                  </td>
                                );
                              }  
                              )}
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      </> }
                      </div>
                  </div>
        </div>
    );
}

// Il competitor si ri-renderizza solo se cambia il suo oggetto, una delle impostazioni globali,
// oppure una delle quote che lo riguardano. Grazie al copy-on-write nel reducer viene toccato
// un solo competitor per quota, invece di tutti quelli dell'evento.
// prev.evento non viene confrontato di proposito: cambia identita' ad ogni quota ed e' usato
// solo per le action, che cercano l'evento per evento_id (vedi indiceEvento nel reducer).
const stessePropsCompetitor = (prev, next) => {
  if (prev.competitor !== next.competitor
    || prev.renderToken !== next.renderToken
    || prev.concessionari !== next.concessionari
    || prev.specialita !== next.specialita
    || prev.alert_abilitati !== next.alert_abilitati
    || prev.classColumns !== next.classColumns
    || prev.tipoVisualizzazione !== next.tipoVisualizzazione
    || prev.evento_id !== next.evento_id) {
    return false
  }
  // confronto delle sole quote del competitor
  const specialita_competitor = next.competitor.specialita
  for (const chiave in specialita_competitor) {
    const quota_id = specialita_competitor[chiave]
    const quota_prev = prev.quoteEvento ? prev.quoteEvento[quota_id] : undefined
    const quota_next = next.quoteEvento ? next.quoteEvento[quota_id] : undefined
    if (quota_prev !== quota_next) {
      return false
    }
  }
  return true
}

export default React.memo(RowCompetitor, stessePropsCompetitor);